export const ROUTE_PATHS = {
  HOME: '/',
  ABOUT: '/about',
  ACADEMICS: '/academics',
  RESEARCH: '/research',
  ADMISSIONS: '/admissions',
  NEWS: '/news',
  COLOR_SWATCH: '/color-swatch',
} as const;

export interface NewsItem {
  id: string;
  title: string;
  excerpt: string;
  category: '综合新闻' | '学术活动' | '通知公告' | '媒体南开';
  date: string;
  image: string;
  author?: string;
  views?: number;
}

export interface College {
  id: string;
  name: string;
  englishName: string;
  category: '理学' | '工学' | '人文' | '社科' | '经管' | '医学';
  description: string;
  disciplines: string[];
  facultyCount: number;
  icon: string;
}

export interface Stat {
  id: string;
  label: string;
  value: number;
  unit: string;
  icon: string;
  description: string;
}

export interface NavItem {
  label: string;
  path: string;
  children?: { label: string; path: string; }[];
}

export interface Notice {
  id: string;
  title: string;
  date: string;
  tag: string;
  tagColor: string;
  link: string;
}

export const NEWS_LIST: NewsItem[] = [
  {
    id: '1',
    title: '南开大学2026年春季学期开学典礼隆重举行',
    excerpt: '2026年春季学期开学典礼在八里台校区体育馆举行，校长出席典礼并发表重要讲话，勉励全体师生砥砺奋进、追求卓越。',
    category: '综合新闻',
    date: '2026-03-01',
    image: 'GRADUATION_2',
    author: '新闻中心',
    views: 3420,
  },
  {
    id: '2',
    title: '南开化学学院科研团队在《Nature》期刊发表重要成果',
    excerpt: '南开大学化学学院功能材料研究团队在有机光电材料领域取得重大突破，相关研究成果于近日发表在国际顶尖学术期刊《Nature》上。',
    category: '学术活动',
    date: '2026-04-15',
    image: 'RESEARCH_1',
    author: '科研处',
    views: 5876,
  },
  {
    id: '3',
    title: '2026年全国硕士研究生招生考试报名通知',
    excerpt: '根据教育部统一部署，2026年全国硕士研究生招生考试报名工作即将开始，请有意报考的同学及时关注招生办公室官方通知。',
    category: '通知公告',
    date: '2026-09-10',
    image: 'CAMPUS_3',
    author: '研究生院',
    views: 12300,
  },
  {
    id: '4',
    title: '南开大学与哈佛大学签署新一轮战略合作协议',
    excerpt: '南开大学校长率代表团访问哈佛大学，双方就深化学术交流、联合科研项目、学生互换项目等方面签署了新一轮全面战略合作协议。',
    category: '综合新闻',
    date: '2026-05-02',
    image: 'CAMPUS_7',
    author: '国际合作处',
    views: 4560,
  },
  {
    id: '5',
    title: '2026年度南开大学学术讲座系列——诺贝尔奖得主报告会',
    excerpt: '南开大学将于本月下旬举办2026年度学术讲座系列，特邀2024年诺贝尔化学奖得主莅临讲坛，与师生共话前沿科学。',
    category: '学术活动',
    date: '2026-05-20',
    image: 'LIBRARY_1',
    author: '学术委员会',
    views: 8900,
  },
  {
    id: '6',
    title: '《人民日报》报道：南开大学在双碳领域取得重要进展',
    excerpt: '《人民日报》头版报道了南开大学环境科学学院在双碳领域的最新研究成果，相关技术已在多个城市推广应用，产生了显著的社会效益。',
    category: '媒体南开',
    date: '2026-04-28',
    image: 'RESEARCH_4',
    author: '宣传部',
    views: 7200,
  },
  {
    id: '7',
    title: '南开大学第十届文化艺术节圆满落幕',
    excerpt: '历时两周的南开大学第十届文化艺术节于昨晚圆满落幕，本届艺术节汇聚了来自全校各院系的三千余名师生共同参与，精彩纷呈。',
    category: '综合新闻',
    date: '2026-04-20',
    image: 'GRADUATION_4',
    author: '校团委',
    views: 2890,
  },
  {
    id: '8',
    title: '南开大学数学科学学院教授荣获2026年度菲尔兹奖提名',
    excerpt: '南开大学数学科学学院王教授因在代数几何领域的杰出贡献，荣获2026年度菲尔兹奖提名，是中国数学界近年来的重要荣誉。',
    category: '学术活动',
    date: '2026-04-10',
    image: 'RESEARCH_3',
    author: '数学科学学院',
    views: 6540,
  },
];

export const COLLEGES: College[] = [
  {
    id: '1',
    name: '化学学院',
    englishName: 'College of Chemistry',
    category: '理学',
    description: '南开化学创建于1921年，是南开大学历史最悠久、最具影响力的学院之一，拥有国家重点实验室。',
    disciplines: ['有机化学', '无机化学', '物理化学', '分析化学', '高分子化学'],
    facultyCount: 186,
    icon: 'Flask',
  },
  {
    id: '2',
    name: '数学科学学院',
    englishName: 'School of Mathematical Sciences',
    category: '理学',
    description: '南开数学以陈省身先生奠定的光辉传统为基础，在几何、拓扑、代数等领域享有国际声誉。',
    disciplines: ['基础数学', '应用数学', '计算数学', '概率与统计', '金融数学'],
    facultyCount: 142,
    icon: 'Calculator',
  },
  {
    id: '3',
    name: '物理科学学院',
    englishName: 'School of Physics',
    category: '理学',
    description: '南开物理学科创立于1923年，在凝聚态物理、光学、理论物理等方向具有深厚积淀。',
    disciplines: ['凝聚态物理', '光学', '理论物理', '天体物理', '粒子物理'],
    facultyCount: 158,
    icon: 'Atom',
  },
  {
    id: '4',
    name: '生命科学学院',
    englishName: 'College of Life Sciences',
    category: '理学',
    description: '南开生命科学学院在细胞生物学、生物化学与分子生物学等领域处于国内领先水平。',
    disciplines: ['细胞生物学', '分子生物学', '生物化学', '遗传学', '神经生物学'],
    facultyCount: 167,
    icon: 'Dna',
  },
  {
    id: '5',
    name: '经济学院',
    englishName: 'School of Economics',
    category: '经管',
    description: '南开经济学科是中国近代经济学教育和研究的摇篮，在理论经济学和应用经济学领域成就卓著。',
    disciplines: ['政治经济学', '西方经济学', '国际经济学', '发展经济学', '产业经济学'],
    facultyCount: 124,
    icon: 'TrendingUp',
  },
  {
    id: '6',
    name: '商学院',
    englishName: 'Business School',
    category: '经管',
    description: '南开商学院以培养具有国际视野和社会责任感的高素质管理人才为己任，获得AACSB国际认证。',
    disciplines: ['工商管理', '市场营销', '财务管理', '人力资源管理', '战略管理'],
    facultyCount: 138,
    icon: 'Briefcase',
  },
  {
    id: '7',
    name: '历史学院',
    englishName: 'School of History',
    category: '人文',
    description: '南开历史学科有着近百年的辉煌历史，在中国古代史、世界史、历史文献学等领域具有重要影响。',
    disciplines: ['中国史', '世界史', '考古学', '历史文献学', '文化遗产'],
    facultyCount: 89,
    icon: 'BookOpen',
  },
  {
    id: '8',
    name: '文学院',
    englishName: 'School of Literature',
    category: '人文',
    description: '南开文学院是中国现代文学教育的重镇，在中国古典文学、现代文学、比较文学等领域享有盛誉。',
    disciplines: ['中国语言文学', '比较文学', '语言学', '古典文献', '现代文学'],
    facultyCount: 96,
    icon: 'Feather',
  },
  {
    id: '9',
    name: '法学院',
    englishName: 'Law School',
    category: '社科',
    description: '南开法学院培养了大批优秀的法律人才，在民商法、国际法、宪法行政法等领域具有重要地位。',
    disciplines: ['民商法', '国际法', '宪法行政法', '刑法', '知识产权法'],
    facultyCount: 112,
    icon: 'Scale',
  },
  {
    id: '10',
    name: '环境科学与工程学院',
    englishName: 'College of Environmental Science and Engineering',
    category: '工学',
    description: '南开环境学科是国内最早建立的环境科学学科之一，在大气污染防治、水污染控制等领域居国内领先地位。',
    disciplines: ['环境科学', '环境工程', '大气科学', '生态学', '环境管理'],
    facultyCount: 143,
    icon: 'Leaf',
  },
  {
    id: '11',
    name: '医学院',
    englishName: 'School of Medicine',
    category: '医学',
    description: '南开大学医学院依托天津市完善的医疗体系，培养具有扎实基础理论和临床技能的高素质医学人才。',
    disciplines: ['基础医学', '临床医学', '公共卫生', '生物医学工程', '医学影像'],
    facultyCount: 201,
    icon: 'Heart',
  },
  {
    id: '12',
    name: '信息技术科学学院',
    englishName: 'College of Information Technology Science',
    category: '工学',
    description: '南开信息技术学院在人工智能、机器学习、计算机视觉、自然语言处理等前沿方向持续产出高质量研究成果。',
    disciplines: ['计算机科学', '人工智能', '软件工程', '网络安全', '数据科学'],
    facultyCount: 176,
    icon: 'Cpu',
  },
];

export const STATS: Stat[] = [
  {
    id: '1',
    label: '建校年份',
    value: 1919,
    unit: '年',
    icon: 'Calendar',
    description: '百余年薪火相传',
  },
  {
    id: '2',
    label: '在校学生',
    value: 35546,
    unit: '人',
    icon: 'Users',
    description: '含本硕博各层次',
  },
  {
    id: '3',
    label: '专职教师',
    value: 2286,
    unit: '人',
    icon: 'GraduationCap',
    description: '高水平师资队伍',
  },
  {
    id: '4',
    label: '学院数量',
    value: 26,
    unit: '个',
    icon: 'Building',
    description: '覆盖多学科领域',
  },
  {
    id: '5',
    label: '科研项目',
    value: 1580,
    unit: '项',
    icon: 'FlaskConical',
    description: '国家级科研项目',
  },
  {
    id: '6',
    label: '国际合作院校',
    value: 280,
    unit: '所',
    icon: 'Globe',
    description: '遍布五大洲',
  },
];

export const NAV_ITEMS: NavItem[] = [
  {
    label: '学校概况',
    path: ROUTE_PATHS.ABOUT,
    children: [
      { label: '历史沿革', path: ROUTE_PATHS.ABOUT },
      { label: '现任领导', path: ROUTE_PATHS.ABOUT },
      { label: '校园风光', path: ROUTE_PATHS.ABOUT },
      { label: '校训与精神', path: ROUTE_PATHS.ABOUT },
    ],
  },
  {
    label: '院系设置',
    path: ROUTE_PATHS.ACADEMICS,
    children: [
      { label: '理学院系', path: ROUTE_PATHS.ACADEMICS },
      { label: '工学院系', path: ROUTE_PATHS.ACADEMICS },
      { label: '人文院系', path: ROUTE_PATHS.ACADEMICS },
      { label: '社科院系', path: ROUTE_PATHS.ACADEMICS },
      { label: '经管院系', path: ROUTE_PATHS.ACADEMICS },
      { label: '医学院系', path: ROUTE_PATHS.ACADEMICS },
    ],
  },
  {
    label: '科学研究',
    path: ROUTE_PATHS.RESEARCH,
    children: [
      { label: '科研机构', path: ROUTE_PATHS.RESEARCH },
      { label: '科研成果', path: ROUTE_PATHS.RESEARCH },
      { label: '重点实验室', path: ROUTE_PATHS.RESEARCH },
      { label: '学术期刊', path: ROUTE_PATHS.RESEARCH },
    ],
  },
  {
    label: '招生就业',
    path: ROUTE_PATHS.ADMISSIONS,
    children: [
      { label: '本科招生', path: ROUTE_PATHS.ADMISSIONS },
      { label: '研究生招生', path: ROUTE_PATHS.ADMISSIONS },
      { label: '博士招生', path: ROUTE_PATHS.ADMISSIONS },
      { label: '留学生招生', path: ROUTE_PATHS.ADMISSIONS },
    ],
  },
  {
    label: '新闻资讯',
    path: ROUTE_PATHS.NEWS,
    children: [
      { label: '综合新闻', path: ROUTE_PATHS.NEWS },
      { label: '学术动态', path: ROUTE_PATHS.NEWS },
      { label: '通知公告', path: ROUTE_PATHS.NEWS },
      { label: '媒体南开', path: ROUTE_PATHS.NEWS },
    ],
  },
];

export const NOTICES: Notice[] = [
  {
    id: '1',
    title: '关于2026年下半年博士研究生招生考试安排的通知',
    date: '2026-05-06',
    tag: '招生',
    tagColor: 'bg-primary/10 text-primary',
    link: ROUTE_PATHS.ADMISSIONS,
  },
  {
    id: '2',
    title: '南开大学2026年度国家自然科学基金项目申报通知',
    date: '2026-05-04',
    tag: '科研',
    tagColor: 'bg-chart-1/20 text-chart-1',
    link: ROUTE_PATHS.RESEARCH,
  },
  {
    id: '3',
    title: '关于举办2026年南开大学运动会的通知',
    date: '2026-05-01',
    tag: '校园',
    tagColor: 'bg-chart-5/20 text-chart-5',
    link: ROUTE_PATHS.NEWS,
  },
  {
    id: '4',
    title: '图书馆2026年暑期开放时间调整通知',
    date: '2026-04-28',
    tag: '服务',
    tagColor: 'bg-chart-4/20 text-chart-4',
    link: ROUTE_PATHS.NEWS,
  },
  {
    id: '5',
    title: '关于申报2026年度南开大学教学成果奖的通知',
    date: '2026-04-25',
    tag: '教学',
    tagColor: 'bg-secondary text-secondary-foreground',
    link: ROUTE_PATHS.NEWS,
  },
  {
    id: '6',
    title: '2026年夏季学位授予典礼时间安排公告',
    date: '2026-04-22',
    tag: '学位',
    tagColor: 'bg-primary/10 text-primary',
    link: ROUTE_PATHS.NEWS,
  },
];
